export const CONTACTS = {
  company: "JCK AUTO",
  legal: "ИП Дьяченко Б.Г.",
  telegram: "https://t.me/jck_auto_manager",
  telegramHandle: "@jck_auto_manager",
  whatsapp: "https://wa.me/79147321950",
  max: "https://max.ru/u/f9LHodD0cOLzVgiZtaFsnUXs9xjCpONlBJckZEFrB4uSKvcaySNMCN6ghIA",
  phone: "+7 (914) 732-19-50",
  phoneRaw: "+79147321950",
  youtube: "https://youtube.com/@JCK_AUTO",
  instagram: "https://www.instagram.com/jckautotrade",
} as const;

export type Country = "china" | "korea" | "japan";
